function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.373 2.5L32 18.158 15.772 25.46l6.86 3.296a.969.969 0 00-.314.117l-1.058.626-1.059-.625a.952.952 0 00-.97 0l-1.058.625-1.058-.625a.953.953 0 00-.97 0l-1.059.625-1.058-.625a.952.952 0 00-.97 0l-.538.317-1.845-3.12 3.347-1.45 1.096.525.14-.504c-.45-.165-.812-.297-.928-.337a.912.912 0 01-.218-.11l-.939-.649-4.13 2.788a1.34 1.34 0 01-.65.222v.011H7.187a1.33 1.33 0 01-.779-.26l.612-.213v-.097H4.267c-.456 0-.699-.113-.957-.358L.798 23.366v-.954c0-.49.182-.75.53-.96l1.725-1.088c.601-.134 1.22-.214 1.987.25l2.533 2.152H8.82l3.388-1.193a.904.904 0 01.302-.049v-.004h.76v.007c.167.004.336.05.485.154l1.948 1.344L21.374 2.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.449 17.046C.676 17.019.028 17.637 0 18.428c-.02.601.323 1.073.83 1.36.308.174.489.36.55.727l.717.026a.638.638 0 00.654-.625l.048-1.388.001-.062c-.006-.763-.6-1.393-1.352-1.42z",
  fill: "currentColor"
})));